'use strict';

angular.module('portal.applications')
    .controller('PortalApplicationResponse', ['$scope', '$stateParams', 'LicenseRequests', function ($scope, $stateParams, LicenseRequests) {
        $scope.response = $stateParams.response;
        $scope.responseID = $stateParams.responseID;
        $scope.fireStartTrigger = $stateParams.fireStartTrigger;
        $scope.applicationID = $stateParams.id;
        $scope.application = $stateParams.application;
        $scope.review = $stateParams.review;
        $scope.applicationLoading = true;

        if ($stateParams.id != null) {
            LicenseRequests.getByID($stateParams.id).then(function (application) {
                $scope.application = application;
                $scope.applicationLoading = false;
            })
        }
        else {
            $scope.application = {};
            $scope.applicationLoading = false;
        }
    }])
;